export const getCustomersListAction = ()=>{
    return {type:"GET_CUSTOMER_ACTION"}
}

export const getCustomersListData = (customerData)=>{
    return {type:"SUCCESSFULLY_GET_CUSTOMER_DATA",payload:customerData }
}

